import { Button } from '@progress/kendo-react-buttons';

export function LearnMore() {
  return (
    <div className="right-box">
      <div className="bottom-margin base-loud-desktop-blue-700">Not yet a customer?</div>
      <div className="learn-more-button">
        <Button
          themeColor={'primary'}
          onClick={() => {
            window.location.href = 'https://accelerationpoint.com/';
          }}
          size="small"
        >
          Learn More
        </Button>
      </div>
    </div>
  );
}
